import auth from 'providers/auth'
import store from 'store'

export function get (url) {
  return _call(url, 'GET')
}

export function post (url, data) {
  return _call(url, 'POST', data)
}

export function put (url, data) {
  return _call(url, 'PUT', data)
}

export function patch (url, data) {
  return _call(url, 'PATCH', data)
}

export function deletex (url) {
  return _call(url, 'DELETE')
}

let errorId = 0

async function _call (...args) {
  store.commit('INCREMENT_PROGRESS')

  try {
    return await _fetch(...args)
  }
  catch (err) {
    let e = err

    if (err.message === 'Failed to fetch') {
      e = {
        message: 'failed_to_connect_to_server'
      }
    }

    const message = e.message || e

    store.commit('SHOW_NOTIFICATION', { message, id: errorId++, type: 'error' })

    throw e
  }
  finally {
    store.commit('DECREMENT_PROGRESS')
  }
}

async function _fetch (url, method, data) {
  const headers = new Headers({
    'Authorization': `Bearer ${auth.token}`,
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  })

  const _options = { headers, method }

  if (data) {
    _options.body = data
  }

  // Convert the body to string if it is not yet a string
  if (_options.body && typeof _options.body !== 'string' && !(_options.body instanceof String)) {
    _options.body = JSON.stringify(_options.body)
  }

  const resourceUrl = `/${url}`

  try {
    const resp = await fetch(resourceUrl, _options)
    const data = await resp.json()

    if (resp.status >= 400) {
      if (resp.status === 401) {
        auth.logout()

        window.location.reload()
      }

      throw data
    }

    return data
  }
  catch (err) {
    if (err.error) throw err.error
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/providers/http.js